import { Link } from "gatsby"
import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"
import Fade from "react-reveal/Fade"
import RightArrowPink from "./../../src/assets/svgs/navigation/Path.svg"
import SVGIcon from "./common/SVGIcon"
import CheckLinkDomain from "./utility/current_domain"

const NavigationDropdown = props => {
  const { navigationLinks } = props.data
  const [subFeaturesIndex, setSubFeaturesIndex] = useState(0)

  const DropdownContents = props => {
    let { el, idx, callBackFn, hideIcon } = props
    return (
      <Link to={el.link} target={CheckLinkDomain(el.link) ? "_self" : "_blank"}>
        <div
          className={`position-relative`}
          onClick={() => callBackFn && callBackFn(idx)}
        >
          <div
            className={`link-box br10 position-relative d-flex ${
              navigationLinks[subFeaturesIndex]?.heading === el.heading
                ? "active-feature"
                : ""
            }`}
          >
            {
              <>
                {el.icon && !hideIcon && (
                  <div
                    className="icon-wrapper"
                    style={{
                      background: el.iconBgColor?.css
                        ? el.iconBgColor.css
                        : "none",
                    }}
                  >
                    <img
                      className="icon"
                      src={el.icon?.url}
                      alt="icon"
                      width="20px"
                    />
                  </div>
                )}
                <div className="position-relative">
                  {el.isNew === "Yes" && (
                    <p className="tag position-absolute m-0">NEW</p>
                  )}
                  <p className="title fw-bold font-roboto">
                    {el.heading}
                    {props.rightArrow && (
                      <RightArrowPink className="r-arrow-pink" />
                    )}
                  </p>
                  <p className="subtext">{el.subText}</p>
                </div>
              </>
            }
          </div>
        </div>
      </Link>
    )
  }

  const DropdownSlider = () => {
    return (
      <div className="drp-down-slider">
        {navigationLinks.map((el, idx) => {
          return (
            <div>
              <DropdownContents
                el={el}
                idx={idx}
                dataLength={props.data.navigationLinks.length}
                rightArrow
                hideIcon
              />
            </div>
          )
        })}
      </div>
    )
  }

  const FadeChildren = props => {
    const { children, idx } = props
    return (
      <Fade delay={idx * 50} bottom>
        {children}
      </Fade>
    )
  }
  switch (props.data.name) {
    case "Features": {
      return (
        <>
          <div className="feature-wrapper-v3 d-flex">
            <div className={`position-relative left`}>
              <p className="p14 gray-color-1 fw-600 feat-title mb30">
                KEY FEATURES
              </p>
              <div className="d-flex flex-column main-features">
                {navigationLinks.map((el, idx) => {
                  return (
                    <div>
                      <DropdownContents
                        el={el}
                        idx={idx}
                        callBackFn={val => setSubFeaturesIndex(val)}
                      />
                    </div>
                  )
                })}
              </div>
              <div className="d-flex align-items-center justify-content-between bottom-box">
                {/* <Link to={"/features"} className="gray-color-2">
                  <p className="p11 m-0">view all features</p>
                </Link> */}
                <Link to="/contact-us" className="gray-color-2">
                  <p className="p11 m-0">Contact us</p>
                </Link>
              </div>
            </div>
            <div className="right position-relative">
              <p className="p14 gray-color-1 fw-600 mb36">FEATURES</p>

              {navigationLinks[subFeaturesIndex].featureNavigationLinks.map(
                (feat, ind) => {
                  return (
                    <FadeChildren idx={ind + 1}>
                      <Link to={feat.link}>
                        <p className="fw-500 p13 mb20 sub-feature position-relative">
                          {feat.heading}
                          <SVGIcon
                            name="navigation/Path"
                            className="r-arrow-pink"
                          />
                          {feat.isNew === "Yes" && (
                            <p className="tag position-absolute m-0">NEW</p>
                          )}
                        </p>
                      </Link>
                    </FadeChildren>
                  )
                }
              )}
              {
                <Link
                  to={`/${navigationLinks[subFeaturesIndex].childFooterLink}`}
                >
                  <p className="p14 fw-bold title-link position-absolute m-0">
                    {navigationLinks[subFeaturesIndex].childFooter}
                    <SVGIcon
                      name="hypertext-arrow-right"
                      className="arrow-right"
                    />
                  </p>
                </Link>
              }
            </div>
          </div>
        </>
      )
    }
    case "Pricing": {
      return (
        <div className="pricing-drpdown">
          {navigationLinks.map(item => {
            return (
              <Link to={item.link}>
                <p className="p14 font-roboto fw-600">{item.heading}</p>
              </Link>
            )
          })}
        </div>
      )
    }
    case "Solutions": {
      return (
        <div className="solutions-drpdown">
          {navigationLinks.map(item => {
            return (
              <Link to={item.link}>
                <div className="link-box">
                  <div className="position-relative">
                    <p className="title fw-bold font-roboto">
                      {item.heading}
                      <RightArrowPink className="r-arrow-pink" />
                    </p>
                    <p className="subtext">{item.subText}</p>
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      )
    }
    case "Season 1":
    case "Mini-resources":
    case "Mini-resources-v2": {
      return <DropdownSlider />
    }
    default: {
      return (
        <>
          <div className="nav-resource-wrapper d-flex justify-content-center">
            <div className="left-side">
              <Row>
                {navigationLinks
                  ?.filter(abc => abc.heading?.toLowerCase() !== "featured")
                  .map((item, idx) => {
                    const navBlocks = item.featureNavigationLinks
                    return (
                      <Col lg={4} className="d-flex flex-column row-gap-8">
                        <p
                          className={`resource-heading mb12 p14 fw-600 gray-color-1 ${
                            item.heading === "NO HEADING"
                              ? "fade-out-effect"
                              : ""
                          }`}
                        >
                          {item.heading}
                        </p>
                        {navBlocks.map(el => {
                          return (
                            <div
                              className={`${
                                props.animeDir === "RtoL"
                                  ? "slide-RtoL"
                                  : "slide-LtoR"
                              } ${props.animeClass && "slide-anime"} `}
                            >
                              <DropdownContents el={el} />
                            </div>
                          )
                        })}
                      </Col>
                    )
                  })}
              </Row>
            </div>
            <div className="right-side">
              {navigationLinks
                ?.filter(abc => abc?.heading?.toLowerCase() === "featured")
                .map((item, idx) => {
                  return (
                    <div className="">
                      <p className="resource-heading mb24 p14 fw-600 gray-color-1">
                        {item.heading}
                      </p>
                      <div className={`featured-img overflow-hidden br10`}>
                        <Link
                          to={item.link}
                          target={
                            CheckLinkDomain(item.link) ? "_self" : "_blank"
                          }
                        >
                          <img src={item.image.url} className="w-100 image" />
                        </Link>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        </>
      )
    }
  }
}

export default NavigationDropdown
